import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { ArrowLeft, FileText, Download } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const RequirementsGeneration = () => {
  const navigate = useNavigate();
  
  const handleViewDetails = (title: string) => {
    navigate(`/agency-solutions?search=${encodeURIComponent(title)}`);
  };

  const knowledgeBases = [
    {
      title: "GSA Space Planning Standards",
      description: "Comprehensive guidelines for federal building space requirements and floor plan optimization",
      type: "Standard",
      lastUpdated: "2024-01-15"
    },
    {
      title: "Automated Floor Plan Generation Framework",
      description: "AI-driven tools for generating efficient floor plans based on occupancy requirements",
      type: "Tool",
      lastUpdated: "2024-02-20"
    },
    {
      title: "Space Requirements Calculator",
      description: "Interactive tool for calculating optimal space allocation based on federal workforce projections",
      type: "Calculator",
      lastUpdated: "2024-01-30"
    },
    {
      title: "Federal Building Code Compliance Guide",
      description: "Requirements and standards for ensuring floor plans meet federal building codes",
      type: "Guide",
      lastUpdated: "2024-02-10"
    },
    {
      title: "Occupancy Planning Best Practices",
      description: "Evidence-based approaches to space planning for federal facilities",
      type: "Best Practice",
      lastUpdated: "2024-01-25"
    }
  ];

  return (
    <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-6">
          <Link to="/gsa-channel" className="inline-flex items-center text-primary hover:text-primary/80 mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to GSA Channel
          </Link>
          <h1 className="text-3xl font-bold mb-2">Requirements Generation: Floor Plan & Space Requirements</h1>
          <p className="text-muted-foreground">
            Knowledge bases and tools for automated requirements generation, floor plan optimization, and space allocation in federal buildings.
          </p>
        </div>

        <div className="grid gap-6">
          {knowledgeBases.map((kb, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <CardTitle className="text-xl mb-2">{kb.title}</CardTitle>
                    <p className="text-muted-foreground">{kb.description}</p>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {kb.type}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      Updated: {kb.lastUpdated}
                    </span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="flex gap-3">
                  <Button variant="outline" size="sm" onClick={() => handleViewDetails(kb.title)}>
                    <FileText className="h-4 w-4 mr-2" />
                    View Details
                  </Button>
                  <Button variant="outline" size="sm">
                    <Download className="h-4 w-4 mr-2" />
                    Download
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
    </div>
  );
};

export default RequirementsGeneration;